import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Este es el único Router que debes usar
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* Solo un BrowserRouter en toda la app */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
